import MainProfile from "../components/profile/main-profile";

function Profile() {
  return (
    <div>
      <MainProfile />
    </div>
  );
}

export default Profile;
